import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.from";
import _slicedToArray from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es7.object.entries";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import _classCallCheck from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { mutate } from './use-swr';
import hash from './libs/hash';

var Cache = /*#__PURE__*/function () {
  function Cache() {
    var initialData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Cache);

    this.__cache = new Map(Object.entries(initialData));
    this.__listeners = [];
  }

  _createClass(Cache, [{
    key: "get",
    value: function get(key) {
      var _this$serializeKey = this.serializeKey(key),
          _this$serializeKey2 = _slicedToArray(_this$serializeKey, 1),
          _key = _this$serializeKey2[0];

      return this.__cache.get(_key);
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var shouldNotify = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var _this$serializeKey3 = this.serializeKey(key),
          _this$serializeKey4 = _slicedToArray(_this$serializeKey3, 1),
          _key = _this$serializeKey4[0];

      this.__cache.set(_key, value);

      if (shouldNotify) mutate(key, value, false);
      this.notify();
    }
  }, {
    key: "keys",
    value: function keys() {
      return Array.from(this.__cache.keys());
    }
  }, {
    key: "has",
    value: function has(key) {
      var _this$serializeKey5 = this.serializeKey(key),
          _this$serializeKey6 = _slicedToArray(_this$serializeKey5, 1),
          _key = _this$serializeKey6[0];

      return this.__cache.has(_key);
    }
  }, {
    key: "clear",
    value: function clear() {
      var shouldNotify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (shouldNotify) this.__cache.forEach(function (key) {
        return mutate(key, null, false);
      });

      this.__cache.clear();

      this.notify();
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      var shouldNotify = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var _this$serializeKey7 = this.serializeKey(key),
          _this$serializeKey8 = _slicedToArray(_this$serializeKey7, 1),
          _key = _this$serializeKey8[0];

      if (shouldNotify) mutate(key, null, false);

      this.__cache["delete"](_key);

      this.notify();
    } // TODO: introduce namespace for the cache

  }, {
    key: "serializeKey",
    value: function serializeKey(key) {
      var args = null;

      if (typeof key === 'function') {
        try {
          key = key();
        } catch (err) {
          // dependencies not ready
          key = '';
        }
      }

      if (Array.isArray(key)) {
        // args array
        args = key;
        key = hash(key);
      } else {
        // convert null to ''
        key = String(key || '');
      }

      var errorKey = key ? 'err@' + key : '';
      return [key, args, errorKey];
    }
  }, {
    key: "subscribe",
    value: function subscribe(listener) {
      var _this = this;

      if (typeof listener !== 'function') {
        throw new Error('Expected the listener to be a function.');
      }

      var isSubscribed = true;

      this.__listeners.push(listener);

      return function () {
        if (!isSubscribed) return;
        isSubscribed = false;

        var index = _this.__listeners.indexOf(listener);

        if (index > -1) {
          _this.__listeners[index] = _this.__listeners[_this.__listeners.length - 1];
          _this.__listeners.length--;
        }
      };
    } // Notify Cache subscribers about a change in the cache

  }, {
    key: "notify",
    value: function notify() {
      var _iterator = _createForOfIteratorHelper(this.__listeners),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var listener = _step.value;
          listener();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }]);

  return Cache;
}();

export { Cache as default };